import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  constructor(private fb: FormBuilder, private http: HttpClient) {}
  contactForm!: FormGroup;
  ngOnInit(): void {
    this.contactForm = this.fb.group({
      InputName: [''],

      InputEmail: [''],
      InputSubject: [''],
      Message: ['']
    });
  }

  onSubmit() {
    this.http.post('https://abrarportfolio-1-default-rtdb.firebaseio.com/contact.json', this.contactForm.value).subscribe(
      (res) => {
        // Handle the response here
        console.log(res);
        this.contactForm.reset()
      },
      (error) => {
        // Handle errors here
        console.error(error);
      }
    );
  }
}
